import { Node } from "@iventis/domain-model/model/node";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { findNode } from "@iventis/tree-browser";

export const FOLDER_LIKE_NODE_TYPES: readonly NodeType[] = [NodeType.Folder, NodeType.Stream, NodeType.Stage];
export const RELAY_CONTAINER_NODE_TYPES: readonly NodeType[] = [NodeType.Stream, NodeType.Stage];

export const isFolderLikeNodeType = (type: NodeType): boolean => FOLDER_LIKE_NODE_TYPES.includes(type);
export const isRelayContainerNodeType = (type: NodeType): boolean => RELAY_CONTAINER_NODE_TYPES.includes(type);

export const isInsideRelayContainer = (tree: Node, node: Node): boolean => {
    if (node == null || tree == null) {
        return false;
    }
    let current = findNode([tree], node.parentId);
    while (current != null) {
        if (isRelayContainerNodeType(current.type)) {
            return true;
        }
        current = findNode([tree], current.parentId);
    }
    return false;
};

export const isRelayContainerOrDescendant = (tree: Node, node: Node): boolean => {
    if (node == null) {
        return false;
    }
    return isRelayContainerNodeType(node.type) || isInsideRelayContainer(tree, node);
};
